import React from 'react';
import { SectionCareerAwards } from './styles';

const STCareerAwardsSection = ({
  awardOne,
  awardTwo,
  awardThree,
  awardFour,
  awardFive,
  ...otherProps
}) => {
  return (
    <SectionCareerAwards {...otherProps}>
      <div className="section-career-awards--container">
        <div className="section-career-awards--content">
          <div className="section-career-awards--item">
            <div className="section-career-awards--image-wrapper">
              <img src={awardOne} />
            </div>
          </div>
          <div className="section-career-awards--item">
            <div className="section-career-awards--image-wrapper">
              <img src={awardTwo} />
            </div>
          </div>
          <div className="section-career-awards--item">
            <div className="section-career-awards--image-wrapper">
              <img src={awardThree} />
            </div>
          </div>
          <div className="section-career-awards--item">
            <div className="section-career-awards--image-wrapper">
              <img src={awardFour} />
            </div>
          </div>
          <div className="section-career-awards--item">
            <div className="section-career-awards--image-wrapper">
              <img src={awardFive} />
            </div>
          </div>
        </div>
      </div>
    </SectionCareerAwards>
  );
};

export default STCareerAwardsSection;
